import React from 'react';
import { Platform, StyleSheet, View } from 'react-native';

import { BigButton } from '@components/Button';
import { ImageBackground } from '@components/Image';
import ScreenContainer from '@components/ScreenContainer';
import { WhiteHeadline, WhiteSubheading } from '@components/Typography';
import { createAppNavigation } from '@navigation/AppNavigation';
import { StartScreenProps } from '@navigation/Types';

export default function StartScreen({ navigation }: StartScreenProps) {
  const appNavigation = React.useMemo(() => createAppNavigation(navigation), [navigation]);

  return (
    <ImageBackground
      source={Platform.select({
        default: require('../assets/images/start.png'),
        web: require('../assets/images/stock-travel.jpeg'),
      })}
      style={styles.image}
      contentFit="cover">
      <ScreenContainer testID="screens.StartScreen.Background" style={styles.background}>
        <WhiteHeadline>Joinstar</WhiteHeadline>
        <WhiteSubheading>Share your plans. Join your friends.</WhiteSubheading>
        <View style={styles.buttonContainer}>
          <BigButton
            mode="contained"
            buttonColor="black"
            onPress={appNavigation.openLogin}
            testID="screens.StartScreen.Button.Login">
            Sign In
          </BigButton>
          <BigButton
            mode="contained"
            buttonColor="white"
            onPress={appNavigation.openRegister}
            testID="screens.StartScreen.Button.Register">
            Sign Up
          </BigButton>
        </View>
      </ScreenContainer>
    </ImageBackground>
  );
}

const styles = StyleSheet.create({
  background: {
    paddingHorizontal: 10,
  },
  buttonContainer: {
    paddingVertical: 10,
    width: '100%',
  },
  image: {
    flex: 1,
  },
});
